import { TabRow } from "./tab-row";
import {ComponentItems} from "./component-Items";

export class ComponentTabs extends ComponentItems {
  public tabItems: TabRow[] = [new TabRow("Tab 1", "tab1")];
}
